module.exports = __webpack_public_path__ + "media/Loops 90 Drums.c5b9dfd9.wav";